import axios from "axios";
import { Intervention } from "../../../types/model/intervention";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/captures`;

export const getCaptureInterventions = async (
  captureId: number,
): Promise<Intervention[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<Intervention[]>(
    `${BASE_URL}/${captureId}/intervention`,
    {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};
